import React from 'react';
import { FaTimes, FaPlus, FaMinus, FaShoppingBag } from 'react-icons/fa';
import '../styles/Cart.css';

const Cart = ({ isOpen, onClose, cartItems, onUpdateQuantity, onRemoveItem, onCheckout }) => {
  const calculateTotal = () => {
    return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  if (!isOpen) return null;

  return (
    <>
      <div className="cart-overlay" onClick={onClose}></div>
      <div className={`cart-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="cart-header">
          <h2>
            <FaShoppingBag /> Your Cart ({totalItems})
          </h2>
          <button className="close-cart" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="cart-body">
          {cartItems.length === 0 ? (
            <div className="empty-cart">
              <FaShoppingBag className="empty-icon" />
              <p>Your cart is empty</p>
              <button className="btn btn-primary" onClick={onClose}>
                Continue Shopping
              </button>
            </div>
          ) : (
            <>
              <div className="cart-items">
                {cartItems.map((item) => (
                  <div key={item.id} className="cart-item">
                    <img src={item.image} alt={item.name} className="cart-item-image" />
                    <div className="cart-item-details">
                      <h4 className="cart-item-name">{item.name}</h4>
                      <p className="cart-item-price">Rs. {item.price}</p>

                      <div className="quantity-controls">
                        <button
                          className="qty-btn"
                          onClick={() => onUpdateQuantity(item.id, item.quantity - 1)}
                          disabled={item.quantity <= 1}
                        >
                          <FaMinus />
                        </button>
                        <span className="quantity">{item.quantity}</span>
                        <button
                          className="qty-btn"
                          onClick={() => onUpdateQuantity(item.id, item.quantity + 1)}
                        >
                          <FaPlus />
                        </button>
                      </div>
                    </div>
                    <button
                      className="remove-item"
                      onClick={() => onRemoveItem(item.id)}
                    >
                      <FaTimes />
                    </button>
                  </div>
                ))}
              </div>

              <div className="cart-footer">
                <div className="cart-total">
                  <span>Subtotal:</span>
                  <span className="total-amount">Rs. {calculateTotal()}</span>
                </div>
                {calculateTotal() >= 3000 && (
                  <div className="free-shipping-notice">
                    You get FREE shipping!
                  </div>
                )}
                {calculateTotal() < 3000 && (
                  <div className="shipping-notice">
                    Add Rs. {3000 - calculateTotal()} more for FREE shipping
                  </div>
                )}
                <button className="btn btn-primary checkout-btn" onClick={onCheckout}>
                  Proceed to Checkout
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Cart;